<template lang="pug">
  #videos
    .container-fluid.py-5
      .row.d-flex.justify-content-center.align-items-center.mb-5
        p.title
          span VIDEOS&nbsp;
          span.bold EXPLICATIVOS
      .row.d-flex.justify-content-center.align-items-center.mb-5
        .row.col-12.col-lg-11.d-flex.justify-content-center.align-items-center
          .col-11.col-lg-4(v-for="v in videos")
            .mx-lg-3.my-3.embed-responsive.embed-responsive-16by9
              iframe(:src="v.embed_url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
</template>

<script>
export default {
  data() {
    return {
      videos: []
    };
  },
  async mounted() {
    this.videos = (await this.$store.dispatch("getVideos")).data;
    //console.log(this.videos);
  }
};
</script>

<style lang="scss">
#videos {
  .title {
    font-family: "Inria Sans", sans-serif;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
    font-weight: 300;
    .bold {
      font-weight: 600;
    }
    @media (max-width: 768px) {
      font-size: 25px;
    }
    @media (min-width: 769px) {
      font-size: 55px;
    }
  }
}
</style>
